"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ARTICLE_BOX_MOBILE_WIDTH = exports.ARTICLE_BOX_DESKTOP_WIDTH = exports.ARTICLE_BOX = void 0;
const ARTICLE_BOX = exports.ARTICLE_BOX = 'article-box';
const ARTICLE_BOX_MOBILE_WIDTH = exports.ARTICLE_BOX_MOBILE_WIDTH = '100%';
const ARTICLE_BOX_DESKTOP_WIDTH = exports.ARTICLE_BOX_DESKTOP_WIDTH = 290;
//# sourceMappingURL=constants.js.map